import { CircularProgress } from "@mui/material";

import { ErrorState } from "../States";
import { StateWrapper } from "./styles";
import { FormPanelLoad } from "./types";

export const PanelState = ({
  status,
  onRetry,
  loadingLabel = "Loading…",
  errorMessage = "Something went wrong. Please try again.",
}: FormPanelLoad) => {
  const handleRetry = async () => {
    onRetry();
  };

  if (status === "error") {
    return (
      <StateWrapper>
        <ErrorState message={errorMessage} onRetry={handleRetry} />
      </StateWrapper>
    );
  }

  return (
    <StateWrapper>
      <CircularProgress size={20} aria-label="Loading" />
      {loadingLabel}
    </StateWrapper>
  );
};
